import styled from 'styled-components';
import { mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  display: flex;
  width: 100%;
  padding: var(--space-300);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-0);

  ${mediaQueries.tablet} {
    padding: var(--space-100);
  }
`;
export const Section = styled.div `
  display: flex;
  flex-direction: column;
`;
export const SectionTitle = styled.div `
  display: flex;
  padding: var(--space-200) var(--space-300) var(--space-100) var(--space-300);
  align-items: center;
  align-self: stretch;
  color: var(--text-secondary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-200); /* 133.333% */
  letter-spacing: var(--font-letter-spacing-looser);
`;
export const Divider = styled.div `
  width: 100%;
  height: 1px;
  background: var(--border-secondary);
  display: flex;
  margin: var(--space-100) 0px;
  align-items: center;
  gap: var(--space-300);
  align-self: stretch;
`;
export const SelectItem = styled.div `
  display: flex;
  padding: var(--space-200) var(--space-300);
  align-items: center;
  gap: var(--space-300);
  align-self: stretch;
`;
